var render, staticRenderFns
import script from "./complaints-file-upload.js?vue&type=script&lang=js&external"
export * from "./complaints-file-upload.js?vue&type=script&lang=js&external"
import style0 from "./complaints-file-upload.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports